﻿$.fn.dxCtrlPopupVerifEmail = function custom_dxCtrlPopupVerifEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpopupverifemail dx-ctrl");
        this.createInstance(new cdxCtrlPopupVerifEmail(this, option));
    }
    return this;
}

window.cdxCtrlPopupVerifEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var popupMaitre = null
    var popupContentElement = null
    var jaugePopup = null
    var dataEncours = null
    function mConstruit() {
        container.empty()
        popupMaitre = container.appendTo("body").dxCtrlPopupBase({
            fullscreen: false,
            height: "auto",
            width: 500,
            minHeight: 500,
            showMaximize: false,
            showCloseButton: false,
            shading: true,
            title: "Vérification d'adresses emails",
            contentTemplate: function (contentElement) {
                popupContentElement = contentElement
                jaugePopup = $("<div/>").appendTo(popupContentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                jaugePopup.mShow()
                if (typeof option.idBatch == 'undefined' || option.idBatch == null) {
                    //on veut initialiser un batch
                    option.bddCtrl.mAjaxCall({ command: "initbatchtraitementverifemail", lst_adresse_email: option.lstAdresseEmail }, function (data) {

                        if (typeof data.data == "undefined" ||
                            typeof JSON.parse(data.data).total_counts == 'undefined' ||
                            JSON.parse(data.data).total_counts.id_email_verif_batch == "0") {
                            mNotify("Impossible de démarrer le test de votre liste d'emails", "warning", 6000)
                            popupMaitre.hide()
                        } else {
                            dataEncours = JSON.parse(data.data).total_counts
                            option.bddCtrl.utiCourant.id_batch = dataEncours.id_email_verif_batch
                            option.idBatch = dataEncours.id_email_verif_batch
                            option.bddCtrl.objCptCli.data.nb_credit_verif_adresse_email = data.nb_credit_verif_adresse_email
                            mUpdateDonut()
                        }
                    }, null, function (data) {
                        mNotify("Impossible de démarrer le test de votre liste d'emails", "warning", 6000)
                        popupMaitre.hide()
                    })
                } else {
                    //on demande a continuer le traitement d'un batch
                    option.bddCtrl.mAjaxCall({ command: "getdatabatchtraitementverifemail", id_batch: option.idBatch }, function (data) {
                        dataEncours = JSON.parse(data.data).total_counts
                        mUpdateDonut()
                    })
                }
                //dataEncours = {
                //    "deliverable": 1,
                //    "processed": 1,
                //    "risky": 0,
                //    "total": 5,
                //    "undeliverable": 0,
                //    "unknown": 0
                //}
                //mUpdateDonut()
            },
            onHiding: function (e) {
                debugger
            },
            onHidden: function (e) {
                if (typeof option.onClose != 'undefined') option.onClose()
            }
        }).dxCtrlPopupBase("instance")
        popupMaitre.show()
    }

    //x = {
    //    "total_counts": {
    //        "deliverable": 1,
    //        "processed": 1,
    //        "risky": 0,
    //        "total": 2,
    //        "undeliverable": 0,
    //        "unknown": 0
    //    }
    //}
    var dxPieChart = null
    var $DivTot = null
    function mUpdateDonut() {
        dataEncours.processed = dataEncours.deliverable + dataEncours.risky + dataEncours.undeliverable + dataEncours.unknown
        //dataEncours.wait = dataEncours.total - dataEncours.processed
        //var ds = [{ type: "deliverable", nb: dataEncours.deliverable },
        //{ type: "risky", nb: dataEncours.risky },
        //{ type: "undeliverable", nb: dataEncours.undeliverable },
        //{ type: "unknown", nb: dataEncours.unknown },
        //{ type: "nb_smtp_mx_no", nb: dataEncours.nb_smtp_mx_no },
        //    { type: "wait", nb: dataEncours.total - dataEncours.processed }]
        var ds = [{ type: "deliverable", nb: dataEncours.deliverable },
        { type: "risky", nb: dataEncours.risky },
        { type: "undeliverable", nb: dataEncours.undeliverable },
        { type: "unknown", nb: dataEncours.unknown }]
        if (dxPieChart) {
            dxPieChart.option("dataSource", ds)
        } else {
            var $DivA = $("<div style='text-align:right;'/>").appendTo(popupContentElement)
            $("<a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/52/Verifier_vos_adresses_emails/bc' target='_blank'>En savoir plus</a>").appendTo($DivA)
            dxPieChart = $("<div/>").appendTo(popupContentElement).dxPieChart({
                dataSource: ds,
                startAngle: 90,
                centerTemplate(pieChart, container) {
                    if (dataEncours.fini_verification != 0) {
                        const text = createText({
                            x: 105,
                            y: 170,
                            fill: theme.color, //'#494949',
                            'text-anchor': 'middle',
                            'font-size': 18,
                        }, ["Terminé", "100%"]);
                        container.appendChild(text)
                    } else {
                        const element = createElement("image", {
                            x: 70,
                            y: 58,
                            width: 80,
                            height: 80,
                            href: parametre.urldispatch + '/img/jauge2.svg'
                        })

                        container.appendChild(element)
                        const text = createText({
                            x: 105,
                            y: 170,
                            fill: theme.color, //'#494949',
                            'text-anchor': 'middle',
                            'font-size': 18,
                        }, ["En cours", Math.floor(dataEncours.processed / dataEncours.total * 100) + "%"]);
                        container.appendChild(text)
                    }

                },
                innerRadius: 0.65,
                resolveLabelOverlapping: 'shift',
                sizeGroup: 'piesGroup',
                onPointClick: function (e) {
                    mShowDetail(e.target.argument)
                },
                onLegendClick: function (e) {
                    mShowDetail(e.target)
                },
                legend: {
                    horizontalAlignment: 'center',
                    verticalAlignment: 'bottom',
                    customizeHint: function (pointInfo) {
                        switch (pointInfo.pointName) {
                            case "deliverable":
                                return "Ces adresses emails sont valides et peuvent recevoir des messages"
                                break;
                            case "risky":
                                return "Ces adresses emails peuvent ne pas être fiables (le domaine accepte toutes les adresses, la boite est pleine ou l'adresse est temporaire ou jetable)"
                                break;
                            case "undeliverable":
                                return "Ces adresses emails n'existent pas ou ne peuvent pas recevoir de messages"
                                break;
                            case "unknown":
                                return "Impossible de savoir si ces adresses emails existent";
                                break;
                            case "wait":
                                return "Ces adresses emails n'ont pas encore été testées";
                                break;
                        }
                    },
                    customizeText: function (pointInfo) {
                        var val = dataEncours[pointInfo.pointName]
                        var result = 0
                        switch (pointInfo.pointName) {
                            case "deliverable":
                                result = "Valide"
                                break;
                            case "risky":
                                result = "Suspectes";
                                break;
                            case "undeliverable":
                                result = "Invalide";
                                break;
                            case "unknown":
                                result = "Inconnus";
                                break;
                            case "wait":
                                result = "En attente";
                                break;
                        }
                        var percent = val / dataEncours.total * 100
                        result = result + "<br/>" + Math.floor(percent) + "%"
                        if (val > 0) result += " (" + val + ")"
                        return result
                    }
                },
                type: 'doughnut',
                series: [{
                    argumentField: 'type',
                    valueField: 'nb',
                    label: {
                        visible: false
                    },
                }],
                customizePoint: function (pointInfo) {
                    switch (pointInfo.argument) {
                        case "deliverable":
                            return { color: "green" };
                            break;
                        case "risky":
                            return { color: "orange" };
                            break;
                        case "undeliverable":
                            return { color: "red" };
                            break;
                        case "unknown":
                            return { color: "SteelBlue" };
                            break;
                        case "wait":
                            return { color: "gainsboro" };
                            break;
                    }
                }
            }).dxPieChart("instance")
            $DivTot = $("<div style='font-size:160%;text-align:center;'/>").appendTo(popupContentElement)
            $DivFin = $("<div style='text-align:center;display:none;'/>").appendTo(popupContentElement)
            jaugePopup.mHide()
        }

        if (dataEncours.fini_verification == 0) {
            $DivTot.html("<b>" + dataEncours.processed + "</b>/" + dataEncours.total + " adresses emails vérifiées")
            //on est sur un batch api
            window.setTimeout(function () {
                option.bddCtrl.mAjaxCall({ command: "getdatabatchtraitementverifemail", id_batch: option.idBatch }, function (data) {
                    dataEncours = JSON.parse(data.data).total_counts
                    mUpdateDonut()
                }, null, function (data) {
                    mUpdateDonut()
                })
            }, 3000)
        } else {
            $DivTot.html("<b>" + dataEncours.total + "</b> adresses emails vérifiées")
            mFin()
        }
    }

    var $DivFin = null
    function mFin() {
        $DivFin.empty()
        var $Div = $("<div style='font-size:100%;color:green;'><b>" + dataEncours.deliverable + "</b> " + ((dataEncours.deliverable > 1) ? "adresses valides" : "adresse valide") + ". </div>").appendTo($DivFin).attr("title", "Ces adresses sont valides et peuvent recevoir des messages")
        $("<a href='javascript:void(0)'>voir</a>").appendTo($Div).on("click", function (e) { mShowDetail("deliverable") })

        var $Div = $("<div style='font-size:100%;color:red;'><b>" + dataEncours.undeliverable + "</b> " + ((dataEncours.deliverable > 1) ? "adresses invalides" : "adresse invalide") + ". </div>").appendTo($DivFin).attr("title", "Ces adresses n'existent pas ou ne peuvent pas recevoir de messages")
        $("<a href='javascript:void(0)'>voir</a>").appendTo($Div).on("click", function (e) { mShowDetail("undeliverable") })

        var $Div = $("<div style='font-size:100%;color:orange;'><b>" + dataEncours.risky + "</b> " + ((dataEncours.risky > 1) ? "adresses suspectes" : "adresse suspecte") + ". </div>").appendTo($DivFin).attr("title", "Ces adresses peuvent ne pas être fiables<br/>(le domaine accepte toutes les adresses, la boite est pleine ou l'adresse est temporaire ou jetable)")
        $("<a href='javascript:void(0)'>voir</a>").appendTo($Div).on("click", function (e) { mShowDetail("risky") })

        var $Div = $("<div style='font-size:100%;color:SteelBlue;'><b>" + dataEncours.unknown + "</b> " + ((dataEncours.unknown > 1) ? "adresses impossibles" : "adresse impossible") + " à évaluer. </div>").appendTo($DivFin).attr("title", "Impossible de savoir si ces adresses existent")
        $("<a href='javascript:void(0)'>voir</a>").appendTo($Div).on("click", function (e) { mShowDetail("unknown") })

        if (dataEncours.undeliverable > 0) {
            $("<div style='margin:8px;'/>").appendTo($DivFin).dxCtrlCheckBox({
                text: ((dataEncours.undeliverable > 1) ? "Placer en hard-bounce les " + dataEncours.undeliverable + " adresses invalides" :
                    "Placer en hard-bounce l'adresse invalide"),
                value: true,
                disabled: true
            })
        }
        var dxChkRisky = null
        if (dataEncours.risky > 0) {
            dxChkRisky = $("<div style='margin:8px;'/>").appendTo($DivFin).dxCtrlCheckBox({
                text: ((dataEncours.risky > 1) ? "Placer en hard-bounce les " + dataEncours.risky + " adresses suspectes" : "Placer en hard-bounce l'adresse suspecte"),
                value: false,
                disabled: false
            }).dxCtrlCheckBox("instance")
        }
        var dxChkInconnu = null
        if (dataEncours.unknown > 0) {
            dxChkInconnu = $("<div style='margin:8px;'/>").appendTo($DivFin).dxCtrlCheckBox({
                text: ((dataEncours.risky > 1) ? "Placer en hard-bounce les " + dataEncours.unknown + " adresses inconnus" : "Placer en hard-bounce l'adresse incoonus"),
                value: false,
                disabled: false
            }).dxCtrlCheckBox("instance")
        }
        var $DivBt = $("<div style='padding-top:10px;'/>").appendTo($DivFin)
        $("<div/>").appendTo($DivBt).dxCtrlButton({
            text: "Valider",
            onClick: function (e) {
                jaugePopup.mShow()
                jaugePopup.option("message", "Mise en bounce des adresses emails")
                var guidImport = generateGuid()
                option.bddCtrl.mAjaxCall({
                    command: "miseenbounceemailemailverifbatch",
                    id_batch: option.idBatch,
                    risky: ((dxChkRisky != null && dxChkRisky.option("value")) ? "1" : "0"),
                    inconnu: ((dxChkInconnu != null && dxChkInconnu.option("value")) ? "1" : "0"),
                    guidprogression: guidImport
                }, function (data) {
                    //jaugePopup.mHide()
                    //mConfirmPopup("<div>Toutes vos adresses emails ont été vérifiées et les adresses problèmatiques on été mises en bounce.</div>", function () { popupMaitre.hide() }, "Ok")

                    function mSurveille() {
                        if (container.closest("body").length == 0) return
                        option.bddCtrl.mAjaxCall({
                            command: "surveilleprogressiontraitement",
                            guidprogression: guidImport
                        }, function (data) {
                            jaugePopup.mAvance("Mise en bounces en cours", data.nb, data.nbtot)
                            if (data.fini == "1") {
                                jaugePopup.mHide()
                                if (data.exmessage && data.exmessage.length > 0) {
                                    mConfirmPopup("<div style='color:red;'>Nous avons rencontré un problème durant la mise ne bounce de vos adresses emails.</div>", function () { popupMaitre.hide() }, "Ok")
                                } else {
                                    mConfirmPopup("<div>Toutes vos adresses emails ont été vérifiées et les adresses problèmatiques on été mises en bounce.</div>", function () { popupMaitre.hide() }, "Ok")
                                    popupMaitre.hide()
                                }
                            } else {
                                //error
                                window.setTimeout(function () { mSurveille() }, 1000)
                            }
                        })
                    }
                    mSurveille()
                }, null, function (data) {
                })
            }
        })
        //var jauge = $("<div/>").appendTo($DivBt).dxCtrlJauge({ width: 40, height: 40 }).dxCtrlJauge("instance")
        //jauge.mShow()
        $DivFin.slideDown(500)
        //option.bddCtrl.mAjaxCall({ command: "finalisebatchtraitementverifemail", id_batch: option.idBatch }, function (data) {
        //    jauge.mHide()
        //})
        //dxPieChart.element().animate({ "opacity": 0.8 }, 500)
    }

    function mShowDetail(argument) {
        option.bddCtrl.mAjaxCall({ command: "getdatabatchtraitementverifemailwithstate", state: argument, id_batch: option.idBatch },
            function (data) {
                if (typeof data.lst_email == 'undefined') data.lst_email = []
                if (data.lst_email.length == 0) {
                    mNotify("Aucune adresse email", "warning", 6000)
                } else {
                    var title = ""
                    switch (argument) {
                        case "deliverable": title = "Adresses emails OK"; break;
                        case "undeliverable": title = "Adresses emails en erreur"; break;
                        case "unknown": title = "Adresses emails impossible a vérifier"; break;
                        case "risky": title = "Adresses emails suspectes"; break;
                    }
                    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                        fullscreen: false,
                        height: "auto",
                        maxHeight: "95%",
                        width: 500,
                        showMaximize: false,
                        showCloseButton: true,
                        shading: true,
                        title: title,
                        contentTemplate: function (contentElement) {
                            contentElement.css("padding", "0 5px 5px 5px")
                            var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                            dxScroll.content().css("padding", "0 20px 20px 20px")
                            dxScroll.content().css("font-family", "barlow condensed")
                            data.lst_email.forEach(function (email) {
                                var $Div = $("<div style='margin:5px;'/>").appendTo(dxScroll.content())
                                switch (argument) {
                                    case "risky": case "unknown":
                                        var $DivClickDeliverable = $("<span style='border-radius:50%;background-color:green;font-size:160%;cursor:pointer;' title='Passez en adresse OK'>&nbsp;⤣&nbsp;</span>").appendTo($Div)
                                        $("<span> &bull; </span>").appendTo($Div)
                                        $DivClickDeliverable.on("click", function () {
                                            $Div.remove()
                                            option.bddCtrl.mAjaxCall({
                                                command: "emailverifchangestatefromrisky",
                                                id_email_verif: email.id_email_verif,
                                                id_email_verif_batch: option.idBatch,
                                                state: "deliverable"
                                            }, function (data) {

                                            })
                                        })
                                        var $DivClickUndeliverable = $("<span style='border-radius:50%;background-color:red;font-size:160%;cursor:pointer;' title='Passez en adresse invalide'>&nbsp;⤥&nbsp;</span>").appendTo($Div)
                                        $("<span> &bull; </span>").appendTo($Div)
                                        $DivClickUndeliverable.on("click", function () {
                                            $Div.remove()
                                            option.bddCtrl.mAjaxCall({
                                                command: "emailverifchangestatefromrisky",
                                                id_email_verif: email.id_email_verif,
                                                id_email_verif_batch: option.idBatch,
                                                state: "undeliverable"
                                            }, function (data) {

                                            })
                                        })
                                        break;
                                }
                                switch (argument) {
                                    case "deliverable":
                                    case "undeliverable": case "unknown": case "risky":
                                        var title = ""
                                        var detail = ""
                                        switch (email.reason) {
                                            case "low_deliverability":
                                                title = "Faible délivrabilité"
                                                detail = "l'adresse e-mail semble être délivrable, mais la délivrabilité ne peut être garantie."
                                                break;
                                            case "low_quality":
                                                title = "Faible qualité"
                                                detail = "l'adresse e-mail présente des problèmes de qualité qui peuvent en faire une adresse risquée ou de faible valeur."
                                                break;
                                            case "unavailable_smtp":
                                                title = "SMTP indisponible"
                                                detail = "Le serveur de messagerie n'était pas disponible pour traiter notre demande à ce moment."
                                                break;
                                            case "unexpected_error":
                                                title = "Erreur inattendue"
                                                detail = "une erreur inattendue s'est produite."
                                                break;
                                            case "timeout":
                                                title = "Délai d'expiration"
                                                detail = "la session du serveur de messagerie ou la requête DNS a expiré."
                                                break;
                                            case "no_connect":
                                                title = "Pas de connexion"
                                                detail = "impossible de se connecter au serveur de messagerie."
                                                break;
                                            case "invalid_email":
                                                title = "E-mail non valide"
                                                detail = "l'adresse e-mail ne passe pas les validations de syntaxe"
                                                break;
                                            case "invalid_domain":
                                                title = "Domaine non valide"
                                                detail = "le domaine de l'adresse e-mail n'existe pas, n'est pas valide ou ne doit pas être envoyé."
                                                break;
                                            case "rejected_email":
                                                title = "E-mail rejeté"
                                                detail = "l'adresse e-mail a été rejetée par le serveur de messagerie car elle n'existe pas."
                                                break;
                                            case "invalid_smtp":
                                                title = "SMTP non valide"
                                                detail = "le serveur de messagerie a renvoyé une réponse inattendue ou non valide."
                                                break;
                                        }
                                        if (title.length > 0) {
                                            var $Sp = $("<span style='border-radius:5px;padding:2px 4px;background-color:LightCoral;'></span>").appendTo($Div).text(title)
                                            $Sp.attr("title", detail)
                                            $("<span> &bull; </span>").appendTo($Div)
                                        }
                                        break;
                                }
                                $("<u></u>").appendTo($Div).text(email.email)
                                if (email.full_name != null && email.full_name.length > 0) {
                                    $("<span> &bull; </span>").appendTo($Div)
                                    $("<span style='font-weight:bold;'></span>").appendTo($Div).text(email.full_name)
                                }
                            })
                        },
                        onShown: function (e) {
                            //popupMaitre.hide()
                        },
                        onHiding: function (e) {
                            if (dataEncours.fini_verification == 1) {
                                option.bddCtrl.mAjaxCall({ command: "getdatabatchtraitementverifemail", id_batch: option.idBatch }, function (data) {
                                    dataEncours = JSON.parse(data.data).total_counts
                                    mUpdateDonut()
                                })
                            }
                        }
                    }).dxCtrlPopupBase("instance")
                    popup.show()
                }
            })
    }

    function createText(attributes, contents) {
        const text = createElement('text', attributes);

        const tspan1 = createElement('tspan', { x: attributes.x, dy: 0 });
        tspan1.textContent = contents[0];

        const tspan2 = createElement('tspan', { x: attributes.x, dy: 40, 'font-size': '200%', 'font-weight': 600 });
        tspan2.textContent = contents[1];

        text.appendChild(tspan1);
        text.appendChild(tspan2);

        return text;
    }

    function createElement(type, attributes) {
        const element = document.createElementNS('http://www.w3.org/2000/svg', type);
        Object.keys(attributes).forEach((attributeName) => {
            element.setAttribute(attributeName, attributes[attributeName]);
        });
        return element;
    }

    this.element = function () { return container; }
    this.component = function () { }

    mConstruit();
}